import {Card, CardContent, Typography, Box, Tooltip, Grid, tooltipClasses} from '@mui/material';
import {ValidateState} from 'lib.common';
import {styled} from '@mui/material/styles';
import {makeStyles} from 'tss-react/mui';

interface InfoCartProps {
   value: number;
   descripcion: string;
   isCriticalValue?: boolean;
}

const useStyles = makeStyles()(theme => ({
   colorPrimary: {
      color: theme.palette.primary.main
   },
   colorError: {
      color: theme.palette.error.main
   },
   colorSuccess: {
      color: theme.palette.success.main
   },
   colorWarning: {
      color: theme.palette.warning.main
   },
   colorNeutro: {
      color: '#9E9E9E'
   }
}));

export const InfoCard: React.FC<InfoCartProps> = ({
   value,
   descripcion,
   isCriticalValue = false
}) => {
   const {classes} = useStyles();

   const color =
      value === 0
         ? classes.colorNeutro
         : isCriticalValue
         ? classes.colorError // rojo
         : classes.colorPrimary //color primario


   return (
      <Grid container>
         <Grid item xs={12}>
            <Card
               sx={{
                  borderRadius: 3,
                  p: 0,
                  boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.15)',
                  border: '1px solid #CECECE'
               }}
            >
               <CardContent
                  sx={{p: 1}}
                  style={{
                     paddingBottom: 8
                  }}
               >
                  <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                     <Box display="flex" alignItems="center">
                        <Typography
                           sx={{
                              fontSize: '2.5rem',
                              fontWeight: 400,
                              lineHeight: 1,
                              margin: 0
                           }}
                           className={color}
                        >
                           {value}
                        </Typography>
                     </Box>
                  </Box>

                  <Grid container justifyContent="center">
                     <Grid item xs={12}>
                        <Typography
                           variant="body1"
                           color="text.disabled"
                           mt={0.5}
                           textAlign="center"
                           lineHeight={1.1}
                           sx={{minHeight: '27px'}}
                        >
                           {descripcion}
                        </Typography>
                     </Grid>
                  </Grid>
               </CardContent>
            </Card>
         </Grid>
      </Grid>
   );
};
